import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    List,
    ListItem,
    ListItemText,
    TextField,
    CircularProgress,
    Box,
    Typography
} from '@mui/material';
import axios from 'axios';
import { api_Routes } from '../../tools/api_Routes';
import { Helper } from '../../tools/Helper';

const TemplateDialog = ({ open, type, onClose, onSelect, onCreateNew }) => {
    const [templates, setTemplates] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTemplates = async () => {
            if (!open) return;

            setLoading(true);
            setError(null);

            try {
                const {response} = await Helper.Get({
                    url: `${api_Routes.Users.EmailTemplates}?type=${type}`,
                    hasToken: true
                });
                if (response && response.success) {
                    setTemplates(response.data || []);
                } else {
                    setError(response?.message || 'Failed to load templates');
                }
            } catch (err) {
                setError('An error occurred while fetching templates');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchTemplates();
    }, [open, type]);

    const filteredTemplates = templates.filter(t =>
        t.name.toLowerCase().includes(search.toLowerCase()) ||
        t.subject.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                {type === 'rich_text' ? 'Rich Text Email Templates' : 'Structured Email Templates'}
            </DialogTitle>

            <DialogContent>
                <TextField
                    fullWidth
                    label="Search templates..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    sx={{ mb: 2 }}
                    disabled={loading}
                />

                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height={200}>
                        <CircularProgress />
                    </Box>
                ) : error ? (
                    <Typography color="error" align="center" py={2}>
                        {error}
                    </Typography>
                ) : filteredTemplates.length === 0 ? (
                    <Typography color="textSecondary" align="center" py={2}>
                        No templates found
                    </Typography>
                ) : (
                    <List sx={{ maxHeight: 400, overflow: 'auto' }}>
                        {filteredTemplates.map((template) => (
                            <ListItem
                                button
                                key={template.id}
                                onClick={() => onSelect(template)}
                            >
                                <ListItemText
                                    primary={template.name}
                                    secondary={
                                        <div>
                                            <div><strong>Subject:</strong> {template.subject}</div>
                                            <div><strong>Created:</strong> {new Date(template.created_at).toLocaleDateString()}</div>
                                        </div>
                                    }
                                    secondaryTypographyProps={{ component: 'div' }}
                                />
                            </ListItem>
                        ))}
                    </List>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="secondary">
                    Cancel
                </Button>
                <Button onClick={onCreateNew} color="primary" variant="contained">
                    Create New
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TemplateDialog;